module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/SBI ELITE Card.1a4deedb.png";